// src/sanitizeAllowList.ts
var KB_EXTRA_TAGS = [
  "video",
  "source",
  "iframe",
  "svg",
  "path"
];
var KB_TAG_ATTRIBUTES = {
  svg: ["className", "viewBox", "version", "width", "height", "ariaHidden"],
  path: ["d", "fillRule", "clipRule"],
  video: [
    "src",
    "controls",
    "width",
    "height",
    "poster",
    "loop",
    "muted",
    "autoplay",
    "playsinline",
    "preload",
    "style",
    "className"
  ],
  source: ["src", "type"],
  iframe: [
    "src",
    "width",
    "height",
    "title",
    "allow",
    "allowfullscreen",
    "frameborder",
    "loading",
    "referrerpolicy",
    "style",
    "className"
  ]
};
var KB_EXTRA_ATTRIBUTES = {
  div: ["className"],
  p: ["className"],
  img: ["loading", "width", "height", "style", "className"]
};
var KB_SRC_PROTOCOLS = ["http", "https"];
var KB_ALL_EXTRA_TAGS = KB_EXTRA_TAGS;
var KB_ALL_EXTRA_ATTRIBUTES = [
  .../* @__PURE__ */ new Set([
    ...Object.values(KB_TAG_ATTRIBUTES).flat(),
    ...Object.values(KB_EXTRA_ATTRIBUTES).flat()
  ])
];
var HTML_ATTRIBUTE_NAMES = {
  className: "class",
  ariaHidden: "aria-hidden",
  fillRule: "fill-rule",
  clipRule: "clip-rule",
  // Genuinely camelCase in SVG, but DOMPurify lowercases before comparing.
  viewBox: "viewbox"
};
function toHtmlAttribute(property) {
  return HTML_ATTRIBUTE_NAMES[property] ?? property.toLowerCase();
}
var KB_ALL_EXTRA_HTML_ATTRIBUTES = [
  ...new Set(KB_ALL_EXTRA_ATTRIBUTES.map(toHtmlAttribute))
];

export { KB_ALL_EXTRA_ATTRIBUTES, KB_ALL_EXTRA_HTML_ATTRIBUTES, KB_ALL_EXTRA_TAGS, KB_EXTRA_ATTRIBUTES, KB_EXTRA_TAGS, KB_SRC_PROTOCOLS, KB_TAG_ATTRIBUTES, toHtmlAttribute };
